export const CHANGE_COMPANY_DATA = 'CHANGE_COMPANY_DATA';
export type CHANGE_COMPANY_DATA = typeof CHANGE_COMPANY_DATA;


// WEBPACK FOOTER //
// ./src/actions/company/change-data/Types.tsx